export default __webpack_public_path__ + "static/hw_ff_button_schem-c49dca0cf2031d38f72a8cb393cbd3bd.png";